<template>
  <div :class="$style.overlay">
    <div :class="$style.reservationParent">
      <b :class="$style.reservation">Reservation</b>
      <b :class="$style.dualInstruction">{{ this.eventEventType.name }}</b>
      <div :class="$style.start0327240730Parent">
        <div :class="$style.start0327240730">Start: {{ this.eventStart }}</div>
        <div>|</div>
        <div :class="$style.start0327240730">End: {{ this.eventEnd }}</div>
      </div>
      <div :class="$style.frameParent">
        <div
          :class="$style.editWrapper"
          v-if="userCanEdit && eventStatus !== 'Checked In'"
          @click="openEdit"
        >
          <div :class="$style.edit">Edit</div>
        </div>
        <div
          :class="$style.checkOutWrapper"
          :style="checkOutButtonStyle"
          v-if="userCanChangeStatus && this.eventEventType.name !== 'Time Off'"
          @click="updateEventStatus('next')"
        >
          <b :class="$style.edit">{{
            skipCheckOut && eventStatus === "Reserved"
              ? "Check In"
              : eventStatus === "Reserved"
                ? "Check Out"
                : eventStatus === "Checked Out"
                  ? "Check In"
                  : eventStatus === "Checked In"
                    ? "Complete"
                    : "Stand By"
          }}</b>
        </div>
      </div>
      <div :class="$style.frameGroup">
        <div :class="$style.reservationGroup">
          <b :class="$style.div">Reservation #</b>
          <div :class="$style.div">{{ this.event.id }}</div>
        </div>
        <div :class="$style.reservationGroup" v-if="this.eventCustomer1">
          <b :class="$style.div">Student Pilot</b>
          <div :class="$style.div">{{ this.eventCustomer1.name }}</div>
        </div>
        <div :class="$style.reservationGroup" v-if="this.eventInstructor">
          <b :class="$style.div">Instructor</b>
          <div :class="$style.div">{{ this.eventInstructor.name }}</div>
        </div>
        <div :class="$style.reservationGroup" v-if="this.eventAircraft">
          <b :class="$style.div">Aircraft</b>
          <div :class="$style.div">
            {{ this.eventAircraft.model }} | {{ this.eventAircraft.tailNumber }}
          </div>
        </div>
        <div :class="$style.reservationGroup">
          <b :class="$style.div">School</b>
          <div :class="$style.div">Venture West Aviation</div>
        </div>
        <!--        <div :class="$style.reservationGroup">-->
        <!--          <b :class="$style.div">Transactions</b>-->
        <!--          <div :class="$style.div">n/a</div>-->
        <!--        </div>-->
        <!--        <div :class="$style.reservationGroup">-->
        <!--          <b :class="$style.div">Flight #</b>-->
        <!--          <div :class="$style.div">n/a</div>-->
        <!--        </div>-->
        <div :class="$style.meterWrapper" v-if="this.eventAircraft">
          <b :class="$style.div">Meter</b>
        </div>
        <div :class="$style.hobbsParent" v-if="this.eventAircraft">
          <b :class="$style.div">Hobbs</b>
          <div :class="$style.div">{{ this.eventAircraft.hobbs }}</div>
        </div>
        <div :class="$style.hobbsParent" v-if="this.eventAircraft">
          <b :class="$style.div">Engine</b>
          <div :class="$style.div">{{ this.eventAircraft.tach }}</div>
        </div>
        <!--        <div :class="$style.meterWrapper">-->
        <!--          <b :class="$style.div">Instruction Time</b>-->
        <!--        </div>-->
        <!--        <div :class="$style.hobbsParent">-->
        <!--          <b :class="$style.div">Flight Instruction</b>-->
        <!--          <div :class="$style.div">1 Hour</div>-->
        <!--        </div>-->
        <!--        <div :class="$style.hobbsParent">-->
        <!--          <b :class="$style.div">Debrief</b>-->
        <!--          <div :class="$style.div">.25 Hours</div>-->
        <!--        </div>-->
        <div
          :class="$style.reservationGroup"
          v-if="
            eventStatus !== 'Reserved' &&
            eventStatus !== 'Standby' &&
            !skipCheckOut
          "
        >
          <b :class="$style.div">Checked Out</b>
          <div :class="$style.div">{{ checkedOutBy }}</div>
        </div>
        <div
          :class="$style.reservationGroup"
          v-if="
            eventStatus !== 'Reserved' &&
            eventStatus !== 'Standby' &&
            !skipCheckOut
          "
        >
          <b :class="$style.div">Check Out Time</b>
          <div :class="$style.div">{{ checkedOutTime }}</div>
        </div>
        <div :class="$style.reservationGroup">
          <b :class="$style.div">Comments</b>
          <div :class="$style.div">
            {{ this.event.comments ? this.event.comments : "No Comments" }}
          </div>
        </div>
        <div :class="$style.reservationGroup">
          <b :class="$style.div">Internal Comments</b>
          <div :class="$style.div">
            {{
              this.event.internalComments
                ? this.event.internalComments
                : "No Internal Comments"
            }}
          </div>
        </div>
        <div :class="$style.reservationGroup">
          <b :class="$style.div">Standby</b>
          <div :class="$style.div">{{ this.event.standby ? "Yes" : "No" }}</div>
        </div>
      </div>
      <img
        @click="closeModal"
        :class="$style.vectorIcon"
        alt=""
        src="/static/img/grey-x.svg"
      />
    </div>
  </div>
</template>
<script>
import EventsHistoryAPIService from "../../../../servicehandlers/EventsHistoryAPIService.js";
const eventsHistoryAPIService = new EventsHistoryAPIService();
import { defineComponent } from "vue";
import { pullObjectInfo } from "./scheduleUtils";
import dayjs from "dayjs";

export default defineComponent({
  props: {
    currentUser: Object,
    event: Object,
    eventTypes: Array,
    eventStatusOptions: Array,
    aircraft: Array,
    instructors: Array,
    rooms: Array,
    customers: Array,
  },
  data() {
    return {
      eventStart: "",
      eventEnd: "",
      eventAircraft: "",
      eventEventType: "",
      eventStatus: "",
      eventInstructor: "",
      eventCustomer1: "",
      eventCustomer2: "",
      eventCustomer3: "",
      eventCustomer4: "",
      eventCustomer5: "",
      userCanChangeStatus: false,
      userCanEdit: false,
      userCanComment: false,
      userCanInternalComment: false,
      checkedOutTime: "",
      checkedOutBy: "",
    };
  },
  async mounted() {
    switch (this.currentUser.userType) {
      case "Admin":
        this.userCanChangeStatus = true;
        this.userCanEdit = true;
        this.userCanComment = true;
        this.userCanInternalComment = true;
        this.userCanHistory = true;
        break;
      case "Instructor":
        this.userCanChangeStatus = true;
        this.userCanEdit = false;
        this.userCanComment = true;
        this.userCanInternalComment = false;
        this.userCanHistory = false;
        break;
      case "Student":
        this.userCanChangeStatus = false;
        this.userCanEdit = false;
        this.userCanComment = false;
        this.userCanInternalComment = false;
        this.userCanHistory = false;
        break;
    }
    this.formatEventTimeframe();
    this.eventEventType = pullObjectInfo(
      this.eventTypes,
      this.event.eventTypeId,
    );
    if (this.event.aircraftId) {
      this.eventAircraft = pullObjectInfo(this.aircraft, this.event.aircraftId);
    }
    if (this.event.instructorId) {
      this.eventInstructor = pullObjectInfo(
        this.instructors,
        this.event.instructorId,
      );
    }
    if (this.event.customer1Id) {
      this.eventCustomer1 = pullObjectInfo(
        this.customers,
        this.event.customer1Id,
      );
    }
    if (this.event.customer2Id) {
      this.eventCustomer2 = pullObjectInfo(
        this.customers,
        this.event.customer2Id,
      );
    }
    if (this.event.customer3Id) {
      this.eventCustomer3 = pullObjectInfo(
        this.customers,
        this.event.customer3Id,
      );
    }
    if (this.event.customer4Id) {
      this.eventCustomer4 = pullObjectInfo(
        this.customers,
        this.event.customer4Id,
      );
    }
    if (this.event.customer5Id) {
      this.eventCustomer5 = pullObjectInfo(
        this.customers,
        this.event.customer5Id,
      );
    }
    if (this.event.eventStatusId) {
      this.eventStatus = pullObjectInfo(
        this.eventStatusOptions,
        this.event.eventStatusId,
      ).name;
    }

    await this.getEventHistory();
  },
  computed: {
    skipCheckOut() {
      return ["Maintenance", "Potential Student"].includes(
        this.eventEventType?.name,
      );
    },
    checkOutButtonStyle() {
      return this.eventStatus === "Checked Out"
        ? "background-color: #17AD58;"
        : "";
    },
  },
  methods: {
    async getEventHistory() {
      return eventsHistoryAPIService
        .getEventById(this.event.id, this.$router)
        .then((response) => {
          for (let i = response.length - 1; i >= 0; i--) {
            const entry = response[i];

            if (entry.changes && entry.changes.includes("Checked Out")) {
              this.checkedOutTime = dayjs(entry.timestamp).format(
                "MM/DD/YY, hh:mm A",
              );
              this.checkedOutBy = entry.userName;
              break;
            }
          }

          this.history = response;
        })
        .catch(() => {});
    },
    formatEventTimeframe() {
      this.eventStart = dayjs(this.event.startDateTime).format(
        "MM/DD/YY, hh:mm A",
      );
      this.eventEnd = dayjs(this.event.endDateTime).format("MM/DD/YY, hh:mm A");
    },
    openEdit() {
      this.$emit("edit-event");
    },
    determineStatusStyle() {
      let color = "";
      if (this.eventStatus === "Checked In")
        color = this.eventEventType.completedColor;
      else if (this.eventStatus === "Checked Out") {
        color = this.eventEventType.startedColor;
      } else {
        color = this.eventEventType.scheduledColor;
      }
      let textColor = this.eventEventType.textColor;
      return `background-color:${color};color:${textColor}`;
    },
    updateEventStatus(action) {
      const statusTransitions = {
        Reserved: {
          next: this.skipCheckOut ? "Checked In" : "Checked Out",
          undo: null,
        },
        "Checked Out": { next: "Checked In", undo: "Reserved" },
        "Checked In": { next: null, undo: "Checked Out" },
      };

      const newStatusName =
        action === "next"
          ? statusTransitions[this.eventStatus]?.next
          : statusTransitions[this.eventStatus]?.undo;

      if (newStatusName) {
        if (newStatusName === "Checked In") {
          this.$emit("check-in", this.event);
        } else {
          this.$emit(
            "event-status-updated",
            this.event,
            this.getStatusIdByName(newStatusName),
          );
        }
      }
    },
    getStatusIdByName(name) {
      const status = this.eventStatusOptions.find(
        (status) => status.name === name,
      );
      return status ? status.id : null;
    },
    toggleShowResHistory() {
      this.showResHistory = !this.showResHistory;
    },
    closeModal() {
      this.$emit("close");
    },
  },
});
</script>
<style module scoped>
.reservation {
  position: absolute;
  top: 30px;
  left: 30px;
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dualInstruction {
  position: absolute;
  top: 79px;
  left: 30px;
  font-size: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.start0327240730 {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.start0327240730Parent {
  position: absolute;
  top: 145px;
  left: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.edit {
  position: relative;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.editWrapper {
  flex: 1;
  border-radius: 5px;
  background-color: rgba(64, 64, 64, 0.25);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
}
.checkOutWrapper {
  flex: 1;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
}
.frameParent {
  position: absolute;
  top: 186px;
  left: 30px;
  width: 640px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  text-align: center;
}
.div {
  position: relative;
}
.reservationGroup {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.meterWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.hobbsParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 0 20px;
}
.frameGroup {
  position: absolute;
  top: 256px;
  left: 30px;
  width: 640px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  height: 550px;
  overflow-y: auto;
}
.vectorIcon {
  position: absolute;
  top: 39px;
  right: 51px;
  width: 12px;
  height: 12px;
  cursor: pointer;
}
.reservationParent {
  width: 700px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
  margin: auto;
  max-height: 90vh;
  height: 90vh;
}
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
}
</style>
